import React from 'react';
import * as d3Scale from 'd3-scale';
import * as d3Interpolate from 'd3-interpolate';
var TEXT_STYLE = { textAnchor: 'middle', fontSize: 7, fill: '#333' };
function linearColorScale(value, mapLayout) {
    var startColor = mapLayout.startColor;
    var endColor = mapLayout.endColor;
    return (d3Scale
        .scaleLinear()
        .domain([0, 130])
        // @ts-ignore
        .range([startColor, endColor])
        // @ts-ignore
        .interpolate(d3Interpolate.interpolateLab)(value));
}
function renderGradient(_a) {
    var svgHeight = _a.svgHeight, svgWidth = _a.svgWidth, mapLayout = _a.mapLayout;
    return Array(40)
        .fill(undefined)
        .map(function (_, i) { return (React.createElement("rect", { key: i, x: svgWidth - 280 + i * 4, y: svgHeight - 50, width: 5, height: "5", fill: "" + linearColorScale(i * 4, mapLayout), stroke: "none" })); });
}
var MapLegend = function (_a) {
    var _b = _a.extremeValues, min = _b.min, max = _b.max, mapLayout = _a.mapLayout, svgWidth = _a.svgWidth, svgHeight = _a.svgHeight;
    return (React.createElement("g", null,
        React.createElement("text", { x: svgWidth - 280, y: svgHeight - 60, style: TEXT_STYLE }, min),
        React.createElement("text", { x: svgWidth - 120, y: svgHeight - 60, style: TEXT_STYLE }, max),
        renderGradient({ svgWidth: svgWidth, svgHeight: svgHeight, mapLayout: mapLayout })));
};
export default MapLegend;
